import { useNavigate, useParams } from 'react-router-dom'

import { selectDocumentSummaryResult } from '../../../store/processDocument/documentSummary'
import { useAppSelector } from '../../../store/hooks'

import { Button } from '../../../components/Button/Button'
import { DocumentTypeSelectDropdown } from '../DocumentTypeSelectDropdown/DocumentTypeSelectDropdown'

export const DocumentSummaryHeader = () => {
  const navigate = useNavigate()

  const documentSummaryResult = useAppSelector(selectDocumentSummaryResult)

  const { userId = null } = useParams()

  const handleBackButtonClicked = () => {
    navigate(userId ? `/library/manage-contacts/contacts/${userId}` : '/')
  }

  return (
    <div className='d-flex align-items-center justify-content-between zocks-pl-2.0 zocks-gap-2 zocks-pr-2.0'>
      <div className='d-flex gap-3 align-items-center'>
        <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
          <i className='bi bi-chevron-left' />
        </Button>
        {!documentSummaryResult ? <span className='paragraph-large'>Document Intelligence</span> : null}
      </div>
      {documentSummaryResult ? (
        <div className='document-summary-type-selector-container'>
          <DocumentTypeSelectDropdown />
        </div>
      ) : null}
    </div>
  )
}
